// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__50UjA","type":"styles_type__yx0_R","choices":"styles_choices__1mawT"};